import { useEffect, useRef } from "react";

export default function GoogleOneTap({ onSuccess }) {
  const initialized = useRef(false);

  useEffect(() => {
    const clientIdMeta = document.querySelector(
      'meta[name="google-signin-client_id"]'
    );
    const clientId = clientIdMeta?.content;

    if (!clientId) {
      console.error("Missing google client_id meta tag");
      return;
    }

    const interval = setInterval(() => {
      if (window.google?.accounts?.id && !initialized.current) {
        clearInterval(interval);

        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: onSuccess, // 🔥 handleGoogleResponse
          auto_select: false,
          cancel_on_tap_outside: false,
        });

        // 🔥 SHOW ONE TAP
        window.google.accounts.id.prompt((notification) => {
          if (notification.isNotDisplayed()) {
            console.warn(
              "One Tap not displayed:",
              notification.getNotDisplayedReason()
            );
          }

          if (notification.isSkippedMoment()) {
            console.warn(
              "One Tap skipped:",
              notification.getSkippedReason()
            );
          }

          if (notification.isDismissedMoment()) {
            console.warn(
              "One Tap dismissed:",
              notification.getDismissedReason()
            );
          }
        });

        initialized.current = true;
      }
    }, 300);

    return () => clearInterval(interval);
  }, [onSuccess]);

  return null; // 🚫 No button, no UI
}
